import Loadable from 'react-loadable';
import { LCLoading } from 'control/loading';

const ResetPassword = Loadable({
  loader: () => import('./resetpassword'),
  loading: LCLoading,
});
export { ResetPassword };
